import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  loading: {
    id: 'product_page_upgrade_loading',
    defaultMessage: 'Scanning for best price',
  },
  upgraded: {
    id: 'product_page_upgrade_upgraded',
    defaultMessage: 'Smart upgrade applied',
  },
  canUpgrade: {
    id: 'product_page_upgrade_can_upgrade',
    defaultMessage: 'Smart upgrade available',
  },
} as Record<string, I18nDefinition>
